<app-base-template (modal)="openModal(content)"  (searchmodal) = "searchModal(scarch_content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Client</div>
  </div>  
  <div class="modal-body hight_modal" style="height: 460px; overflow: auto;">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="name"
             placeholder="Client Name">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="clientCode"
             placeholder="Client code">
    </div>
    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="cliAddr" placeholder="Client Address"></textarea>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="keyPerson"
             placeholder="Enter Key Person Name">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="keyEmail"
             placeholder="Enter Key Person Email Id">
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="keyMobile"
             placeholder="Enter Key Person Mobile">
    </div>
    <div class="form-group">
      <mat-slide-toggle (toggleChange)="keyPersonChecked()" [checked]="personChecked"><b class="blue">Same As Key Person</b>
      </mat-slide-toggle>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="spocPerson"
             placeholder="Enter Bussiness Spoc Name">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="spocEmail"
             placeholder="Enter Bussiness Spoc Email Id">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="spocMobile"
             placeholder="Enter Bussiness Spoc Mobile">
    </div>
    <!--<mat-form-field>-->
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" placeholder="Search Zone.." [(ngModel)]="zoneSelected"
             matInput [formControl]="searchTerm"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngIf="isLoading" class="is-loading">
          <mat-spinner diameter="50"></mat-spinner>
        </mat-option>
        <ng-container *ngIf="!isLoading">
          <mat-option *ngFor="let zone of zones" [value]="zone.name">
            {{ zone.name }}
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="uploadpath"
             placeholder="Enter upload path">
    </div>
    <!--</mat-form-field>-->
    <div class="form-group">
      <mat-slide-toggle (toggleChange)="hourChange()" [checked]="hourChecked"><b class="blue">Use same business hour
        for
        all working days</b>
      </mat-slide-toggle>
    </div>
    <div [hidden]="!hourChecked">

        <div class="form-group">
            <b>Hours start :</b>
            <select class="custom-select radius-0 font-13 size1" [(ngModel)]="hoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
            
              <select class="custom-select radius-0 font-13 size1" [(ngModel)]="minsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>
  
  
          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt20" [owlDateTime]="dt20"
                 placeholder="Bussiness Hour Start" [(ngModel)]="hourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt20></owl-date-time> -->
        </div>
  
      <div class="form-group">
          <b>Hours End :</b>

          <select class="custom-select radius-0 font-13 size1" [(ngModel)]="hoursEnd">
              <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
            </select> <b>:</b>
            <select class="custom-select radius-0 font-13 size1" [(ngModel)]="minsEnd" >
                <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
            </select>

        <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt21" [owlDateTime]="dt21"
               placeholder="Bussiness Hour End" [(ngModel)]="hourEnd" readonly>
        <owl-date-time [pickerType]="'timer'" #dt21></owl-date-time> -->
      </div>
      <div class="form-group font-13">
        <mat-checkbox *ngFor="let day of days" value="{{day.id}}" [(ngModel)]="day.checked">{{day.day}}</mat-checkbox>
      </div>
    </div>
    <table class="table table-bordered font-13 dayChecked" [hidden]="hourChecked">
        <thead>
            <tr>
              <th scope="col"  class = "radius-0 font-13 text-center	">Days</th>
              <th scope="col" class = "radius-0 font-13 text-center">Start Time</th>
              <th scope="col" class = "radius-0 font-13 text-center">End Time</th>
            </tr>
          </thead>
      <tbody>
      <tr>
        <td>
          <mat-checkbox value="0" [(ngModel)]="sunChck">Sun</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="sunHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="sunMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1"
                   placeholder="Bussiness Hour Start" [(ngModel)]="sunHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt1></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="sunHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="sunMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2"
                   placeholder="Bussiness Hour End" [(ngModel)]="sunHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt2></owl-date-time> -->
        </td>
      </tr>
      <tr>
        <td>
          <mat-checkbox value="1" [(ngModel)]="monChck">Mon</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="monHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="monMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3"
                   placeholder="Bussiness Hour Start" [(ngModel)]="monHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt3></owl-date-time> -->
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="monHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="monMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>


          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4"
                   placeholder="Bussiness Hour End" [(ngModel)]="monHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt4></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="2" [(ngModel)]="tueChck">Tue</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="tueHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="tueMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt15" [owlDateTime]="dt15"
                   placeholder="Bussiness Hour Start" [(ngModel)]="tueHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt15></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="tueHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="tueMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          
          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt16" [owlDateTime]="dt16"
                   placeholder="Bussiness Hour End" [(ngModel)]="tueHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt16></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="3" [(ngModel)]="wedChck">Wed</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="wedHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="wedMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt7" [owlDateTime]="dt7"
                   placeholder="Bussiness Hour Start" [(ngModel)]="wedHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt7></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="wedHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="wedMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>


          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt8" [owlDateTime]="dt8"
                   placeholder="Bussiness Hour End" [(ngModel)]="wedHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt8></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="4" [(ngModel)]="thurChck">Thurs</mat-checkbox>
        </td>
        <td> 
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="thurHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="thurMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt9" [owlDateTime]="dt9"
                   placeholder="Bussiness Hour Start" [(ngModel)]="thurHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt9></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="thurHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="thurMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10"
                   placeholder="Bussiness Hour End" [(ngModel)]="thurHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt10></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="5" [(ngModel)]="friChck">Fri</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="friHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="friMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt11" [owlDateTime]="dt11"
                   placeholder="Bussiness Hour Start" [(ngModel)]="friHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt11></owl-date-time> -->
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="friHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="friMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          
          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt12" [owlDateTime]="dt12"
                   placeholder="Bussiness Hour End" [(ngModel)]="friHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt12></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="6" [(ngModel)]="satChck">Sat</mat-checkbox>
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="satHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="satMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt13" [owlDateTime]="dt13"
                   placeholder="Bussiness Hour Start" [(ngModel)]="satHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt13></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="satHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="satMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt14" [owlDateTime]="dt14"
                   placeholder="Bussiness Hour End" [(ngModel)]="satHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt14></owl-date-time> -->
      </tr>

      </tbody>
    </table>


    <div class="form-group">
      <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt5" [owlDateTime]="dt5"
             placeholder="Activation Start" [(ngModel)]="dateStart">
      <owl-date-time [pickerType]="'calendar'" #dt5></owl-date-time>
    </div>
    <mat-slide-toggle (toggleChange)="slideChange()" [checked]="slideChecked"><b class="blue">Life Time Activation</b>
    </mat-slide-toggle>
    <div class="form-group" [hidden]="slideChecked">
      <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt6" [owlDateTime]="dt6"
             placeholder="Activation End" [(ngModel)]="dateEnd">
      <owl-date-time [pickerType]="'calendar'" #dt6></owl-date-time>
    </div>
    <div class="form-group font-13 check">
      <mat-checkbox [(ngModel)]="grpCheck">   Please check if Holiday and SLA to be Support Group Wise<br> (If not checked the SLA and Holiday would be Client Wise)</mat-checkbox>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="text-center">
        <span class="font-13">Upload LOGO:</span>  <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                 (complete)="onFileComplete($event)" [formData]="formData"
                                 (uploadError)="onFileError($event)"></app-material-fileupload>
      </div>
      <div class="col-sm-6 pad-15 text-center upload-msg">{{attachMsg}}
      </div>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<ng-template #content1 let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Edit Client</div>

  </div>
  <div class="modal-body" style="height: 460px; overflow: auto;">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="name"
             placeholder="Client Name" pattern="^[a-zA-Z_\-]+$">
    </div>
    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="cliAddr" placeholder="Client Address"></textarea>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="keyPerson"
             placeholder="Enter Key Person Name">
    </div>
    <div class="form-group">
      <input type="email" class="form-control radius-0 font-13" [(ngModel)]="keyEmail"
             placeholder="Enter Key Person Email Id">
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="keyMobile"
             placeholder="Enter Key Person Mobile">
    </div>
    <!--<div class="form-group">-->
      <!--<mat-slide-toggle (toggleChange)="keyPersonChecked()" [checked]="personChecked"><b class="blue">Same As Key Person</b>-->
      <!--</mat-slide-toggle>-->
    <!--</div>-->
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="spocPerson"
             placeholder="Enter Bussiness Spoc Name">
    </div>
    <div class="form-group">
      <input type="email" class="form-control radius-0 font-13" [(ngModel)]="spocEmail"
             placeholder="Enter Bussiness Spoc Email Id">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="spocMobile"
             placeholder="Enter Bussiness Spoc Mobile">
    </div>
    <!--<mat-form-field>-->
    <!-- <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" placeholder="Search Zone.." [(ngModel)]="zoneSelected"
             matInput [formControl]="searchTerm"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngIf="isLoading" class="is-loading">
          <mat-spinner diameter="50"></mat-spinner>
        </mat-option>
        <ng-container *ngIf="!isLoading">
          <mat-option *ngFor="let zone of zones" [value]="zone.name">
            {{ zone.name }}
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </div> -->
    <!--</mat-form-field>-->
    <!--<div class="form-group">-->
      <!--<mat-slide-toggle (toggleChange)="hourChange()" [checked]="hourChecked"><b class="blue">Use same bussiness hour-->
        <!--for-->
        <!--all working days</b>-->
      <!--</mat-slide-toggle>-->
    <!--</div>-->
    <!--<div [hidden]="!hourChecked">-->
      <!--<div class="form-group">-->
        <!--<input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt20" [owlDateTime]="dt20"-->
               <!--placeholder="Bussiness Hour Start" [(ngModel)]="hourStart">-->
        <!--<owl-date-time [pickerType]="'timer'" #dt20></owl-date-time>-->
      <!--</div>-->
      <!--<div class="form-group">-->
        <!--<input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt21" [owlDateTime]="dt21"-->
               <!--placeholder="Bussiness Hour End" [(ngModel)]="hourEnd">-->
        <!--<owl-date-time [pickerType]="'timer'" #dt21></owl-date-time>-->
      <!--</div>-->
      <!--<div class="form-group font-13">-->
        <!--<mat-checkbox *ngFor="let day of days" value="{{day.id}}" [(ngModel)]="day.checked">{{day.day}}</mat-checkbox>-->
      <!--</div>-->
    <!--</div>-->
    <table class="table table-bordered font-13 dayChecked" [hidden]="hourChecked">
        <thead>
            <tr>
              <th scope="col"  class = "radius-0 font-13 text-center	">Days</th>
              <th scope="col" class = "radius-0 font-13 text-center">Start Time</th>
              <th scope="col" class = "radius-0 font-13 text-center">End Time</th>
            </tr>
          </thead>
      <tbody>
      <tr>
        <td>
          <mat-checkbox value="0" [(ngModel)]="sunChck">Sun</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="sunHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="sunMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1"
                   placeholder="Bussiness Hour Start" [(ngModel)]="sunHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt1></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="sunHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="sunMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2"
                   placeholder="Bussiness Hour End" [(ngModel)]="sunHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt2></owl-date-time> -->
        </td>
      </tr>
      <tr>
        <td>
          <mat-checkbox value="1" [(ngModel)]="monChck">Mon</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="monHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="monMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3"
                   placeholder="Bussiness Hour Start" [(ngModel)]="monHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt3></owl-date-time> -->
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="monHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="monMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>


          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4"
                   placeholder="Bussiness Hour End" [(ngModel)]="monHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt4></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="2" [(ngModel)]="tueChck">Tue</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="tueHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="tueMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt15" [owlDateTime]="dt15"
                   placeholder="Bussiness Hour Start" [(ngModel)]="tueHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt15></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="tueHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="tueMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          
          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt16" [owlDateTime]="dt16"
                   placeholder="Bussiness Hour End" [(ngModel)]="tueHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt16></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="3" [(ngModel)]="wedChck">Wed</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="wedHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="wedMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt7" [owlDateTime]="dt7"
                   placeholder="Bussiness Hour Start" [(ngModel)]="wedHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt7></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="wedHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="wedMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>


          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt8" [owlDateTime]="dt8"
                   placeholder="Bussiness Hour End" [(ngModel)]="wedHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt8></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="4" [(ngModel)]="thurChck">Thurs</mat-checkbox>
        </td>
        <td> 
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="thurHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="thurMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt9" [owlDateTime]="dt9"
                   placeholder="Bussiness Hour Start" [(ngModel)]="thurHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt9></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="thurHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="thurMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10"
                   placeholder="Bussiness Hour End" [(ngModel)]="thurHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt10></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="5" [(ngModel)]="friChck">Fri</mat-checkbox>
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="friHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="friMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt11" [owlDateTime]="dt11"
                   placeholder="Bussiness Hour Start" [(ngModel)]="friHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt11></owl-date-time> -->
        </td>
        <td>

            <select class="custom-select radius-0 font-13 size" [(ngModel)]="friHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="friMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          
          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt12" [owlDateTime]="dt12"
                   placeholder="Bussiness Hour End" [(ngModel)]="friHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt12></owl-date-time> -->
      </tr>
      <tr>
        <td>
          <mat-checkbox value="6" [(ngModel)]="satChck">Sat</mat-checkbox>
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="satHoursStart">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="satMinsStart" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt13" [owlDateTime]="dt13"
                   placeholder="Bussiness Hour Start" [(ngModel)]="satHourStart" readonly>
          <owl-date-time [pickerType]="'timer'" #dt13></owl-date-time> -->
        </td>
        <td>
            <select class="custom-select radius-0 font-13 size" [(ngModel)]="satHoursEnd">
                <option *ngFor="let hour of hours" [ngValue]="hour">{{hour}}</option>
              </select> <b>:</b>
              <select class="custom-select radius-0 font-13 size" [(ngModel)]="satMinsEnd" >
                  <option *ngFor="let min of mins" [ngValue]="min">{{min}}</option>
              </select>

          <!-- <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt14" [owlDateTime]="dt14"
                   placeholder="Bussiness Hour End" [(ngModel)]="satHourEnd" readonly>
          <owl-date-time [pickerType]="'timer'" #dt14></owl-date-time> -->
      </tr>

      </tbody>
    </table>


    <div class="form-group">
      <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt5" [owlDateTime]="dt5"
             placeholder="Activation Start" [(ngModel)]="dateStart">
      <owl-date-time [pickerType]="'calendar'" #dt5></owl-date-time>
    </div>
    <mat-slide-toggle (toggleChange)="slideChange()" [checked]="slideChecked"><b class="blue">Life Time Activation</b>
    </mat-slide-toggle>
    <div class="form-group" [hidden]="slideChecked">
      <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt6" [owlDateTime]="dt6"
             placeholder="Activation End" [(ngModel)]="dateEnd">
      <owl-date-time [pickerType]="'calendar'" #dt6></owl-date-time>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="uploadpath"
             placeholder="Enter File Upload Path for this CLient">
    </div>

    <div class="form-group font-13 check">
      <mat-checkbox [(ngModel)]="grpCheck">   Please check if Holiday and SLA to be Support Group Wise<br> (If not checked the SLA and Holiday would be Client Wise)</mat-checkbox>
    </div>
    <div class="form-group">
      <img src="{{logoUrl}}" class="form-control radius-0 font-13 logo">
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="text-center">
        <span class="font-13">Upload LOGO:</span> <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                                                     (complete)="onFileComplete($event)" [formData]="formData"
                                                                     (uploadError)="onFileError($event)"></app-material-fileupload>
      </div>
      <div class="col-sm-6 pad-15 text-center upload-msg">{{attachMsg}}
      </div>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="update()">Update</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body ">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Client Name"
                 [(ngModel)]="clientSelected"
                 matInput [formControl]="searchData"[matAutocomplete]="auto"
                >
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getDetails()">
              <mat-option *ngIf="isLoading1" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
              </mat-option>
              <ng-container *ngIf="!isLoading1">
                  <mat-option *ngFor="let client of clients" [value]="client.NAME">
                    {{ client.NAME }}
                  </mat-option>
              </ng-container>
          </mat-autocomplete>
      </div>
      <div class="form-group">
          <input type="text" class="form-control radius-0 font-13" placeholder="Client Code" readonly
                 [(ngModel)]="code">
      </div>
  </div>
  <div class="modal-footer pad-8">

          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>

  </div>

  </ng-template>
<notifier-container></notifier-container>
